// extracted by css-extract-rspack-plugin
export default {"FloatingButton":"QuestionDownloadPopover-module__FloatingButton___fv6kX"};